<!--
 * @Description: 
 * @Date: 2021-08-18 15:53:32
-->
<template>
  <el-button
    type="primary"
    @click="submit"
    :loading="loading"
    :disabled="loading"
  >
    {{ needVerify ? '确认并进入下一个项目' : '进入下一个项目' }}
  </el-button>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { nextProject } from '@/api/ajax';
import { getStorage } from '@/tools/storage';
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    submitFn: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({
      projectId: state => state.homeProject.id,
      type: state => state.homeProject.type
    }),
    needVerify() {
      //   projectStatus //项目状态  0 乙方待编辑  1  乙方编辑完成   2 甲方待确认   3 甲方编辑完成
      //   auditStatus //审核状态  0 未提交审核  1 审核中  2 审核未通过  3  审核通过
      const { auditStatus, projectStatus } = this.info;
      if (
        projectStatus == 2 ||
        (projectStatus == 3 && ![1, 3].includes(auditStatus))
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['setHomeQuery']),
    async submit() {
      console.log(this.$route.path);
      if (this.loading) {
        return;
      }
      this.loading = true;
      if (this.needVerify && typeof this.submitFn === 'function') {
        try {
          await this.submitFn(this.type);
        } catch (error) {
          this.loading = false;
          return;
        }
      }
      const {
        data: { data }
      } = await nextProject({
        currentProjectId: this.projectId,
        ...(getStorage('home-search-query') || {})
      });
      if (!data || data.id == this.projectId) {
        this.$alert('本项目是本次撮合的最后一个项目');
        this.loading = false;
        return;
      }
      if (data) {
        // 项目主要参数

        this.setHomeQuery(data).then(() => {
          this.$router.replace({
            path:
              this.$route.path == '/edit/index'
                ? '/edit/index-next'
                : '/edit/index',
            query: {
              id: data.id
            }
          });
        });
      }

      this.loading = false;
    }
  },
  created() {
    const { auditStatus, projectStatus } = this.info;
    console.log('审核阶段=>', projectStatus);
    console.log('审核状态=>', auditStatus);
  }
};
</script>
<style lang="scss" scoped></style>
